module.exports = __webpack_public_path__ + "static/img_pledge_interview_05-fd68fd2e73d860e1511a8666dc9b1f14.png";